import { render } from "./Modal.vue?vue&type=template&id=beee1486&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=beee1486&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-beee1486"

export default script